import React, { useEffect, useState } from "react";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import api from "../../api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { dateStyle: "medium", timeStyle: "short" }) : "never");

export const useWebhookHealth = () => {
  const [h, setH] = useState(null);
  useEffect(() => { api.get("/admin/webhook-health").then(({ data }) => setH(data)).catch(() => {}); }, []);
  return h;
};

export const WebhookAlert = ({ health, onOpen }) => {
  if (!health?.alert) return null;
  return (
    <div className="mb-6 rounded-2xl bg-red-50 border border-red-200 px-5 py-4 flex flex-wrap items-center justify-between gap-3" data-testid="webhook-alert">
      <p className="text-sm text-red-700 flex items-center gap-2"><AlertTriangle size={17} /> <span><strong>Stripe webhook:</strong> {health.alert}</span></p>
      <button onClick={onOpen} data-testid="webhook-alert-open" className="rounded-full bg-red-600 text-white px-4 py-2 text-xs font-semibold">Check settings</button>
    </div>
  );
};

export const WebhookHealthPanel = ({ health }) => {
  if (!health) return null;
  return (
    <div className="rounded-xl border border-gray-100 bg-white p-4" data-testid="webhook-health">
      <p className="text-sm font-medium text-[#16243b] flex items-center gap-1.5">
        {health.alert ? <AlertTriangle size={15} className="text-red-500" /> : <CheckCircle2 size={15} className="text-green-600" />} Webhook health
      </p>
      <p className="text-xs text-[#5a6b80] mt-1" data-testid="webhook-last">Last received: <strong>{fmt(health.last_ok_at)}</strong>{health.last_type && ` (${health.last_type})`} · Failures in last 24h: <strong>{health.failures_24h}</strong></p>
      {health.recent.length > 0 && (
        <ul className="mt-2 max-h-40 overflow-y-auto text-xs divide-y divide-gray-50">
          {health.recent.map((r, i) => (
            <li key={i} className="py-1.5 flex justify-between gap-3" data-testid={`webhook-log-${i}`}>
              <span className={r.ok ? (r.error ? "text-amber-600" : "text-[#16243b]") : "text-red-600"}>{r.ok ? `${r.type || "event"}${r.error ? ` – ${r.error}` : ""}` : `Rejected${r.type ? ` ${r.type}` : ""}: ${r.error}`}</span>
              <span className="text-[#8a97a8] shrink-0">{fmt(r.at)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
